import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import { reinitiateTreatment } from 'api/treatmentAPI';
import { handleError } from 'services/Error';

const Title = 'Reinitiate Therapy';

export const ReinitiateTherapyTreatmentDialog = ({
    isOpen,
    onClose,
    treatmentDetails = undefined,
    submitCallback,
}) => {
    const { treatmentId, payerId } = treatmentDetails ?? {};
    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            onSubmit={async (_values, { resetForm }) => {
                try {
                    await reinitiateTreatment(payerId, treatmentId);

                    submitCallback();

                    SuccessToast({ message: 'Treatment reinitiated successfully.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError('Unable to reinitiate treatment. Please try again.', err);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen={isOpen}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel={Title}
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <div className="margin__bottom--medium">
                            This action mimics submitting from the payer to our platform.
                        </div>
                    }
                />
            )}
        </Formik>
    );
};

ReinitiateTherapyTreatmentDialog.Title = Title;

ReinitiateTherapyTreatmentDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentDetails: PropTypes.shape({
        treatmentId: PropTypes.string,
        payerId: PropTypes.string,
    }),
    submitCallback: PropTypes.func.isRequired,
};
